import styled from 'styled-components';

export const StyledInfoBoxSensor = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #000000e5;
  padding: 8px;
  border-radius: 4px;
  border: 0.5px solid #333333;
  min-height: 100px;

  > div {
    color: #fff;
  }

  .title {
    font-size: 14px;
    font-weight: 400;
  }

  .spacer {
    height: 0.5px;
    width: 100%;
    background: #3a3a3a;
    margin: 4px 0;
  }

  .content {
    font-size: 16px;
    font-weight: 600;
  }

  .degree {
    font-size: 10px;
    font-weight: 400;
  }
`;
